import React from 'react';
import PropTypes from 'prop-types';
import { Slider } from 'antd';
import {Button, Input, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {logFirebaseEvent} from "../../firebase/analytics";

const accuracyMarks = {
    0: {style: {left: 0, transform: 'translateX(0%)'}, label: 'Not accurate at all'},
    25: {},
    50: 'Somewhat accurate',
    75: {},
    100: {style: {left: '100%', transform: 'translateX(-100%)'}, label: 'Incredibly accurate'},
};

const relevanceMarks = {
    0: {style: {left: 0, transform: 'translateX(0%)'}, label: 'Completely irrelevant'},
    25: {},
    50: 'Somewhat relevant',
    75: {},
    100: {style: {left: '100%', transform: 'translateX(-100%)'}, label: 'Incredibly relevant'},
};

class SendFeedback extends React.Component {
    state = {
        accuracy: 50,
        relevance: 50,
        moveAccuracySlider: false,
        moveRelevanceSlider: false,
        comment: '',
    };

    toggleSendFeedbackModal = () => {
        this.resetSendFeedbackModal();
        this.props.toggleOpen();
    };

    resetSendFeedbackModal = () => {
        this.setState({
            accuracy: 50,
            relevance: 50,
            moveAccuracySlider: false,
            moveRelevanceSlider: false,
            comment: '',
        })
    }

    sendFeedback = async () => {
        this.toggleSendFeedbackModal();
        const feedbackStats = {
            accuracy: (this.state.accuracy / 25) + 1,
            relevance: (this.state.relevance / 25) + 1,
            postable_id: this.props.item.postable_id,
            feedback_type: this.props.item.postable_type,
            comment: this.state.comment
        }
        logFirebaseEvent({
            event: 'add_feedback',
            action: (feedbackStats.accuracy + feedbackStats.relevance) > 5 ? "positive" : "negative",
        });
        await this.props.sendFeedback(feedbackStats);
    }

    handleAccuracySliderValueChange = newValue => {
        this.setState({
            accuracy: newValue,
            moveAccuracySlider: true
        });
    };

    handleRelevanceSliderValueChange = newValue => {
        this.setState({
            relevance: newValue,
            moveRelevanceSlider: true
        });
    };

    render() {
        return (
            <Modal
                isOpen={this.props.isOpen}
                centered
                style={{ maxWidth: '600px', width: '100%' }}
            >
                <ModalHeader toggle={this.toggleSendFeedbackModal}>
                    <div>Feedback</div>
                </ModalHeader>
                <ModalBody>
                    <p style={{ marginBottom: 20 }}>To help us ensure content is helpful and highly relevant, please let us know how useful this content has been to you.</p>
                    <h5>Accuracy</h5>
                    <p style={{ marginBottom: 20 }}>Please rate this content on how accurate it is; 1 - Not accurate at all, 3 - Somewhat accurate, 5 - Incredibly accurate</p>
                    <Slider
                        step={25}
                        min={0}
                        max={100}
                        marks={accuracyMarks}
                        tooltipVisible={false}
                        defaultValue={this.state.accuracy}
                        onChange={this.handleAccuracySliderValueChange}
                    />
                    <h5>Relevance</h5>
                    <p style={{ marginBottom: 20 }}>Please rate this content on how relevant it is to you and this app in general; 1 - Completely irrelevant, 3 - Somewhat relevant, 5 - Incredibly relevant</p>
                    <Slider
                        step={25}
                        min={0}
                        max={100}
                        marks={relevanceMarks}
                        tooltipVisible={false}
                        defaultValue={this.state.relevance}
                        onChange={this.handleRelevanceSliderValueChange}
                    />
                    <h5>Comments</h5>
                    <Input
                        type="textarea"
                        name="text"
                        id="comment"
                        placeholder={'Comment (optional)'}
                        maxLength={1000}
                        onChange={(e) => this.setState({
                            comment: e.target.value
                        })}
                    />
                </ModalBody>
                <ModalFooter>
                    <div style={{ flex: 1 }} />
                    <Button color="primary" onClick={this.sendFeedback}>
                        SEND FEEDBACK
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}

SendFeedback.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggleOpen: PropTypes.func.isRequired,
    item: PropTypes.object.isRequired,
    sendFeedback: PropTypes.func.isRequired,
};

export default SendFeedback;
